<template>
  <div id="recipe-detail">
    <div class="content">
      <div style="text-align: center;display:flex;align-items: center;width: 100%;"
           :style="{'height': loaderHeight + 'px'}" v-if="isLoading">
        <div style="margin:0 auto">
          <img width="100px" src="static/loader-gif.gif" class="rounded"/>
          <br/>
          {{$t('message.loadingText')}}
        </div>
      </div>
      <div v-if="!isLoading">
        <div class="relative bottom">
          <img style="background: white" v-if="!imageLoaded" width="100%"
               src="data:image/png;base64,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">
          <div  ref="imagesContainer" class="imgLoadContainer" style="text-align: center;margin-bottom: 24px;">
            <img v-show="recipe.photoLargeUri !== null && imageLoaded" :src="recipe.photoLargeUri" width="100%">
            <img v-show="recipe.photoLargeUri == null && imageLoaded" src="static/recipe-placeholder.png"
                 width="100%">
            <div v-if="!imageLoaded" :style="{'height': imageLoaderHeight}"
                 style="text-align: center;display:flex;align-items: center;width: 100%;">
              <mu-circular-progress
                style="margin: 0 auto; margin: 0px auto; position: absolute;height: 100%;width: 100%;vertical-align: middle;align-items: center;display: flex;text-align: center;align-content: center;top: 0;left: calc(50% - 16px);"></mu-circular-progress>
            </div>
          </div>
          <div class="absoluteTopRight">
            <mu-float-button
              v-if="recipe.userFavorites"
              @click.native="onFavorite"
              :icon="'favorite'"
              background-color="red" style="color: white;"/>
            <mu-float-button
              v-if="!recipe.userFavorites"
              @click.native="onFavorite"
              :icon="'favorite_border'"
              v-tooltip.left="$t('message.addToFavouritesText')"
              background-color="red" style="color: white;"/>
            <mu-float-button
              class="printPage"
              @click.native="printRecipe"
              :icon="'print'"
              v-tooltip.right="$t('message.printPageText')"
              background-color="#0179d5" style="color: white;"/>
          </div>
          <div class="absoluteBottomLeft">
            <div class="greyBox" v-tooltip.top="$t('message.labelPrepTime')">
              <mu-icon :size="16" value="timer"></mu-icon>
              {{recipe.preparationTime}}min
            </div>
            <div v-if="recipe.cookingTime !== 0" class="greyBox" v-tooltip.top="$t('message.labelCookingTime')">
              <img class="svgIcon" src="static/ic_cooktime.svg"/>
              {{recipe.cookingTime}}min
            </div>
            <div class="greyBox" v-tooltip.top="'Servings'">
              <mu-icon :size="16" value="restaurant"></mu-icon>
              {{recipe.servings}}
            </div>

            <div class="greyBox" v-if="recipe.userFavoriteCount !== 0">
              <mu-icon :size="16" value="favorite"></mu-icon>
              {{recipe.userFavoriteCount}}
            </div>
          </div>
        </div>
        <div class="insetTitleMobile">
          <mu-row gutter>
            <mu-col width="100" desktop="100" tablet="100">
              <mu-row>
                <mu-col width="100" desktop="100" tablet="100">
                  <div style="margin-bottom: 24px">
                    <mu-raised-button  class="fullWidthMobileBtn" @click.native="openAddToDiaryModal" backgroundColor="#0179d5" label="Add to food diary"></mu-raised-button>
                  </div>
                  <h1>{{recipe.title}}</h1>
                  <div v-if="recipe.author" class="authorBlock">
                    <p>By {{recipe.author.firstName}} {{recipe.author.lastName}}</p>
                  </div>
                  <recipe-rating
                    style="margin-bottom: 24px;"
                    :read-only="true"
                    :count="recipe.rating.ratingCount"
                    :rating="recipe.rating.ratingScore"
                    :recipe="recipe"

                  ></recipe-rating>


                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
        </div>
        <mu-row gutter>
          <mu-col width="100" desktop="70" tablet="60">


            <mu-card class="bottom">
              <mu-card-text>
                <number-spinner style="float:right" v-if="recipe" v-model="recipe.servings" icon="person"></number-spinner>
                <h2 style="margin-top:0;padding-top:0">Introduction</h2>
                <p>{{recipe.intro}}</p>
                <div v-if="recipe.suitabilities.length > 0">
                  <h3>Allergens</h3>
                  <div>
                    <mu-chip v-for="item, sKey in recipe.suitabilities" :key="'s-' + sKey">
                      {{item.label}}
                    </mu-chip>
                  </div>
                </div>
                <div v-if="recipe.dietaryTypes.length > 0">
                  <h3>Dietary types</h3>
                  <div>
                    <mu-chip v-for="item, dKey in recipe.dietaryTypes" :key="'d-' + dKey">
                      {{item.label}}
                    </mu-chip>
                  </div>
                </div>
                <div v-if="recipe.occasions.length > 0">
                  <h3>Occasions</h3>
                  <div>
                    <mu-chip v-for="item, oKey in recipe.occasions" :key="'o-' + oKey">
                      {{item.label}}
                    </mu-chip>
                  </div>
                </div>
                <div style="clear:both"></div>
              </mu-card-text>
            </mu-card>

            <mu-card class="bottom" v-if="recipe.video_url">
              <mu-card-header title="Watch video" titleClass="blueTitle largeTitle"></mu-card-header>
              <div class="embedContainer">
                <iframe-video-player autoplay="off" :src="recipe.video_url" width="100%" :options="playerOptions"></iframe-video-player>
              </div>
            </mu-card>

            <mu-card class="bottom">
              <mu-card-header title="Ingredients" titleClass="blueTitle largeTitle"></mu-card-header>
              <mu-list>
                <mu-list-item
                  v-for="item, ingredientI in ingredients" :key="'ingredient-' + ingredientI"
                  :title="item.ingredientTitle"
                >
                  <!--Code reverted-->
                  <div slot="describe">
                    <!--<span>-->
                      <!--<span>{{item.portionQuantity}} {{item.portionName}} ({{item.portionValue.toFixed(1) + item.portionUnit}})</span>-->
                    <!--</span>-->

                    <!--<div v-html="$sanitize(item.portionValue.toFixed(1) + item.portionUnit  + '')"></div>-->
                    <span v-if="item.portionName !== 'Serving'">
                      <span>{{item.portionQuantity}} {{item.portionName}} ({{item.portionValue.toFixed(1) + item.portionUnit}})</span>
                    </span>

                    <div v-else v-html="item.portionQuantity.toFixed(1) + item.portionUnit  + ''"></div>
                    <!--<div>{{(item.portionQuantity * item.portionValue) + item.portionUnit}} </div>-->

                    <div>
                      <span v-if="item.allergens.length > 0">Allergens: </span>
                      <span v-for="allergen, allergyIndex in item.allergens" :key="'allergy-index-' + allergyIndex"
                            v-if="item.allergens.length > 0">{{allergen.name}}<span
                        v-if="allergyIndex != item.allergens.length - 1">, </span>
                    </span>
                    </div>


                  </div>
                </mu-list-item>
              </mu-list>
            </mu-card>

            <mu-card class="bottom" style="padding-bottom: 8px">
              <mu-card-header title="Step-by-step" titleClass="blueTitle largeTitle"></mu-card-header>
              <div style="display: none;" class="cookingInstructions" v-html="$sanitize(recipe.cookingInstructions)"></div>
              <mu-list-item v-for="item, i in recipe.cookingInstructions.steps" :key="'instruction-' + i "
                            :title="parseHtmlEncoding(item)">
                <mu-avatar
                  slot="left"
                  color="#0179d5"
                  backgroundColor="#E9E9E8">
                  {{i + 1}}
                </mu-avatar>
              </mu-list-item>
            </mu-card>
            <recipe-reviews class="bottom hidePrint" :recipe="recipe" @ratingPicked="onRatingPicked"></recipe-reviews>
          </mu-col>
          <mu-col width="100" desktop="30" tablet="40">
            <mu-card class="bottom hidePrint">
              <mu-card-text>
                <food-pie
                  :enable-animation="false"
                  style="height: 200px; width: 200px; margin: 24px auto"
                  class="foodPie"
                  :fat="nutrition.fat.val"
                  :carbs="nutrition.carbohydrate.val"
                  :protein="nutrition.protein.val"
                  :calories="nutrition.kcal.val"
                ></food-pie>
                <mu-row align="center" style="width: 100%; margin-top: 16px;">
                  <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#4ed8da !important" badgeClass="smallBadge" content="" circle></mu-badge>
                  <span>  {{nutrition.carbohydrate.val.toFixed(0)}}g</span>
                </span>
                    <br/>
                    <label class="grey" v-text="$t('message.nutrientCarbohydrateShort')"></label>
                  </mu-col>
                  <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#c04dd8 !important" badgeClass="smallBadge" content="" circle></mu-badge>
                  <span> {{nutrition.fat.val.toFixed(0)}}g</span>
                </span>
                    <br/>
                    <label class="grey" v-text="$t('message.nutrientFat')">Fat</label>
                  </mu-col>
                  <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#e06950 !important" badgeClass="smallBadge" content="" circle></mu-badge>
                   <span> {{nutrition.protein.val.toFixed(0)}}g</span>
                </span>
                    <br/>
                    <label class="grey" v-text="$t('message.nutrientProtein')"></label>
                  </mu-col>
                </mu-row>
              </mu-card-text>
            </mu-card>
            <mu-card class="bottom">
              <mu-card-header title="Nutritional information" :subTitle="'Per 1 serving'" titleClass="blueTitle largeTitle"></mu-card-header>
              <div>
                <div class="nutritionList">
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientCarbohydrate')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.carbohydrate.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientSugar')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.sugars.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientFat')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.fat.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientMonounsaturatedFat')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.monoFat.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientPolyunsaturatedFat')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.polyFat.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientSaturatedFat')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.satFat.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientProtein')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.protein.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientFibre')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.fibre.val.toFixed(0)}}g
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      {{$t('message.nutrientPotassium')}}
                    </div>
                    <div class="rightItem">
                      {{nutrition.potassium.val.toFixed(0)}}mg
                    </div>
                  </div>
                  <div class="item">
                    <div class="leftItem">
                      Salt
                    </div>
                    <div class="rightItem">
                      {{nutrition.salt.val.toFixed(0)}}g
                    </div>
                  </div>
                </div>
              </div>
            </mu-card>
          </mu-col>
        </mu-row>
      </div>
    </div>
    <div v-if="!isLoading" style="margin-left: -24px;margin-right: -24px;background: transparent;"
         class="mobileSliderPadding">
      <h2 v-if="similarRecipes.recipes.length > 0" style="padding-left: 16px;padding-top:16px;margin-bottom:2px">Similar
        recipes</h2>
      <mu-row gutter class="dietaryTypes" v-if="similarRecipes.recipes.length > 0">
        <mu-col width="100" desktop="100" tablet="100" v-for="item, dtIndex in similarRecipes.recipes"
                :key="'dt-index-' + dtIndex">
              <horizontal-scroller :title="item.grouping" :grouping-type="item.groupingType" :grouping-route="item.grouping" :recipes="item.recipes"></horizontal-scroller>
        </mu-col>
      </mu-row>
    </div>

    <mu-dialog :open="isFoodDiaryDialogOpen" title="Add this recipe to your food diary" @close="onDialogClose">
      <div>


        <mu-row>
          <mu-col>


            <div class="mu-text-field-label">
              Date and time
            </div>

            <date-picker v-model="model.date"></date-picker>


            <mu-text-field :min="0" style="margin-bottom: 20px;" full-width label="Servings" v-model="model.servings"
                           type="number"></mu-text-field>


            <div class="mu-text-field-label">
              Meal type
            </div>


            <div class="select" style="position: relative">


              <svg viewBox="0 0 24 24" class="customMenu-icon">
                <path d="M7 10l5 5 5-5z"></path>
              </svg>
              <select class="borderedSelect" v-model="model.mealTypeId" style="margin-top: 8px;width: 100%">
                <option v-for="item in mealTypes" :value="item.value">{{item.label}}</option>
              </select>
            </div>

          </mu-col>
        </mu-row>


      </div>


      <mu-flat-button slot="actions" @click="isFoodDiaryDialogOpen = false" primary :label="$t('message.closeText')"/>
      <mu-raised-button :disabled="isRecipeSaving" slot="actions" @click="addToFoodDiary" primary
                        :label="$t('message.saveText')"/>
    </mu-dialog>

  </div>
</template>
<script>
  import _ from 'lodash'
  import $ from 'jquery'
  import RecipeApi from '../../api/Recipes'
  import HorizontalScroller from "./Components/HorizontalScroller";
  import NumberSpinner from "./Components/NumberSpinner";
  import TitleManager from '../../helpers/TitleManager'
  import RecipeRating from "./Components/RecipeRating";
  import RecipeReviews from "./Components/RecipeReviews";
  import imagesLoaded from 'imagesloaded'
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";
  import MuListItem from "muse-ui/src/list/listItem";
  import HTMLStringParser from '../../helpers/HTMLStringParser'
  import DatePicker from "../../components/DateTimePicker/DateTimePicker";
  import MuSelectField from "muse-ui/src/selectField/selectField";
  import MuTextField from "muse-ui/src/textField/textField";

  export default {
    components: {
      MuTextField,
      MuSelectField,
      DatePicker,
      MuListItem,
      MuCircularProgress,
      RecipeReviews,
      RecipeRating,
      NumberSpinner,
      HorizontalScroller
    },
    name: "detail",
    data() {
      return {
        isRecipeSaving: false,
        model: {
          mealTypeId: 1,
          recipeId: null,
          date: moment().format(),
          servings: 1
        },
        mealTypes: [
          {
            value: 1,
            label: this.$t('message.foodDiaryBreakfast')
          },
          {
            value: 2,
            label: this.$t('message.foodDiaryLunch')
          },
          {
            value: 3,
            label: this.$t('message.foodDiaryDinner')
          },
          {
            value: 4,
            label: this.$t('message.foodDiarySnack')
          }
        ],
        isFoodDiaryDialogOpen: false,
        imageLoaderHeight: 0,
        loaderHeight: 0,
        isLoading: true,
        imageLoaded: false,
        recipe: {
          userFavorites: false
        },
        instructions: [],
        refresh: true,
        hideUl: false,
        servings: 1,
        playerOptions: {
          // videojs options
          muted: false,
          fluid: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
          poster: "/static/images/author.jpg",
        },
        similarRecipes: {recipes: []},
      }
    },
    watch: {
      '$route': 'getData'
    },
    methods: {
      printRecipe() {
        let self = this;
        window.open(`https://recipe-gen.lowcarbprogram.com/generateFile/${self.recipe.id}`);
      },
      parseHtmlEncoding(html) {
        return HTMLStringParser.encode(html);
      },
      onDialogClose() {
        this.isRecipeSaving = false;
        this.isFoodDiaryDialogOpen = false;
      },
      openAddToDiaryModal() {
        this.isFoodDiaryDialogOpen = true;
      },
      addToFoodDiary() {
        let self = this;
        self.model.recipeId = self.recipe.id;
        self.isRecipeSaving = true;

        RecipeApi.addToFoodDiary(self.model)
          .then(function () {
            self.onDialogClose();
            let timer = setTimeout(function () {
              self.$alert({
                title: self.$t('message.labelSuccess'),
                text: self.$t('message.recipeAddedToDiary'),
                type: "success",
                showCancelButton: false,
                confirmButtonColor: "white"
              })
              clearTimeout(timer);
            }, 500);
          })
          .catch(function (error) {

          });
      },
      onFavorite() {
        let self = this;
        RecipeApi.favorite(self.recipe.id)
          .then(function (response) {
            let data = response.data;
            self.recipe.userFavorites = data.favorite;
          });
      },
      onRatingPicked(rating) {
        this.recipe.rating = rating;
        this.$forceUpdate();
      },
      getData() {
        let self = this;
        self.isLoading = true;

        self.imageLoaded = false;
        TitleManager.setTitle(self.$t('message.loadingText'));
        RecipeApi.getById(self.$route.params.id)
          .then(function (response) {
            self.recipe = response.data;
            self.$nextTick(function () {


              self.model.servings = self.recipe.servings;

              TitleManager.setTitle(response.data.title)
              self.similarRecipes.recipes = [];


              if (self.recipe.video_url !== null) {
                self.playerOptions.poster = self.recipe.recipePhotoLargeUri;
                self.playerOptions.sources = [
                  {
                    type: 'video/mp4',
                    src: self.recipe.video_url
                  }
                ]
              }

              let occasions = [];
              let suitabilities = [];
              let dietaryTypes = [];

              let query = {
                page: 0,
                limit: 25
              };
              self.recipe.occasions.forEach(function (item) {
                occasions.push(item.label);
              });
              if (occasions.length > 0) {
                Object.assign(query, {
                  occasions: occasions.join(',')
                });
              }

              self.recipe.suitabilities.forEach(function (item) {
                suitabilities.push(item.label);
              });
              if (suitabilities.length > 0) {
                Object.assign(query, {
                  suitabilities: suitabilities.join(',')
                });
              }

              self.recipe.dietaryTypes.forEach(function (item) {
                dietaryTypes.push(item.label);
              });
              if (dietaryTypes.length > 0) {
                Object.assign(query, {
                  dietaryTypes: dietaryTypes.join(',')
                });
              }

              self.$nextTick(function () {
                self.isLoading = false;

                imagesLoaded($('.imgLoadContainer'), function () {
                  setTimeout(function () {
                    self.imageLoaded = true;
                    self.$forceUpdate();
                  }.bind(self), 500);
                });

                self.$forceUpdate();

                RecipeApi.group(query)
                  .then(function (response) {
                    self.similarRecipes = response.data;
                  });
                let cookingInstructions = [];
                let $listContainer = $('.cookingInstructions ul li');
                $listContainer.each(function (item, el) {
                  let text = $(this).eq(item).prevObject[0].outerText;
                  if (text !== "" && text !== undefined && text !== null) {
                    cookingInstructions.push(text);
                    self.instructions = cookingInstructions;
                    self.servings = self.recipe.servings;
                  }
                });
              });
            })
          })
      }
    },
    mounted() {
      let self = this;
      const loaderHeight = $('.main-content').outerHeight();
      self.loaderHeight = loaderHeight;
      self.getData();
    },
    computed: {
      ingredients() {
        let self = this;
        let copyIngredients = JSON.parse(JSON.stringify(self.recipe.ingredients));
        for (let key in copyIngredients) {
          if (!copyIngredients.hasOwnProperty(key)) continue;
          let obj = copyIngredients[key];
          if (_.has(obj, 'portionQuantity') && _.has(obj, 'portionValue')) {
            obj.portionValueOriginal = obj.portionValue;
            obj.computedQuantity = obj.portionQuantity * self.servings / self.recipe.servings;
            // obj.computedPortionValue = obj.portionValue;
            // obj.portionValue = ((obj.portionQuantity * obj.computedPortionValue) / self.recipe.servings) * self.servings;
          }
        }
        return copyIngredients;
      },
      nutrition() {
        let self = this;
        let copyNutrition = JSON.parse(JSON.stringify(self.recipe.nutrition));
        for (let key in copyNutrition) {
          if (!copyNutrition.hasOwnProperty(key)) continue;
          let obj = copyNutrition[key];
          if (_.has(obj, 'val')) {
            obj.val = (obj.val / self.recipe.servings) * self.servings;
          }
        }
        return copyNutrition;
      }
    }
  }
</script>

<style lang="less">

  .printPage {
    &.mu-float-button {
      margin-left: 5px;
    }
  }

  .imgLoadContainer {
    @media(max-width: 800px) {
      margin: -8px;
      margin-bottom: 22px !important;
    }
  }

  .customMenu-icon {
    position: absolute;
    right: 8px;
    top: 10px;
    color: rgb(188, 189, 192);
    fill: currentColor;
    display: inline-block;
    width: 24px;
    height: 24px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    z-index: 0;
  }

  .borderedSelect {
    border: none;
    outline: none;
    -webkit-appearance: none;
    -webkit-border-radius: 0px;
    border-bottom: 1px solid rgba(176, 177, 181, 0.85);
    border-radius: 0;
    background: transparent;
    height: 28px;;
    position: relative;
    z-index: 1;
    padding-bottom: 8px;
  }

  .mu-popover {
    z-index: 1111111111 !important;
  }

  #recipe-detail {
    span.mediumTitle {
      font-size: 16px !important;
    }
  }

  #recipe-detail .mu-card-header-title {
    padding-right: 0px !important
  }

  @media (max-width: 800px) {
    .mobileSliderPadding {
      margin-left: -8px !important;
      margin-right: -8px !important;
    }
  }

  .video-js .vjs-big-play-button {
    font-size: 3em;
    line-height: 1.5em;
    height: 1.5em;
    width: 3em;
    display: block;
    position: absolute;
    top: 45% !important;
    left: 45% !important;
    padding: 0;
    cursor: pointer;
    opacity: 1;
    border: 1px solid #fff;
    background-color: rgb(0, 170, 85) !important;
    border-radius: .3em;
    transition: all .4s;
  }

  .video-js:hover .vjs-big-play-button {
    border-color: #fff;
    background-color: rgba(0, 170, 85, 0.64) !important;
    transition: all 0s;
  }

  .video-js .vjs-control-bar {
    display: none;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    background-color: #2b333f;
    background-color: rgba(1, 121, 214, 0.32);
  }

  .embedContainer {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .rounded {
    border-radius: 50%;
    shape-outside: circle();
  }

  @media (max-width: 800px) {
    .insetTitleMobile {
      padding-left: 24px;
      padding-right: 24px;
    }
  }

  #recipe-detail {
    @media(max-width: 800px) {
      .fullWidthMobileBtn {
        width: 100%;
      }
  }


    .authorBlock {
      margin-bottom: 16px;
    }

    h1 {
      font-size: 28px !important;
      color: rgb(1, 121, 213) !important;
    }

    .svgIcon {
      width: 16px;
      margin-right: 8px;
    }

    .nutritionList .item:nth-child(even) {
      background: #0179d50a;
    }

    .nutritionList .item {
      padding: 16px;
    }

    .nutritionList .item .leftItem {
      float: left;
    }
    .nutritionList .item .rightItem {
      float: right;
    }

    .nutritionList .item:after {
      content: '';
      display: block;
      clear: both;
    }

    .mu-list > div:nth-child(even) {
      background: #0179d50a;
    }

    .mu-item-title {
      line-height: 1.2;
    }

    .nutrientValues {
      color: #0179d5;
      margin-bottom: 16px;
      font-size: 16px;
      span {
        margin-right: 8px;
      }
    }
    .relative {
      position: relative;
      .absoluteTopRight {
        position: absolute;
        top: 16px;
        right: 16px;
      }

      .absoluteBottomLeft {
        position: absolute;
        bottom: 16px;
        left: 16px;
        .greyBox {
          i {
            margin-right: 8px;
          }
          -webkit-border-radius: 8px;
          -moz-border-radius: 8px;
          border-radius: 8px;
          padding: 8px;
          background: rgba(51, 51, 51, 0.6);
          color: white;
          display: inline-flex;
          align-items: center;
          vertical-align: middle;
          font-size: 14px;
        }
      }
    }
  }

  @media print {
    .mu-card-text {
      h2 {
        font-size: 22pt!important;
      }
      font-size: 18pt!important;
    }
    .mu-card {
      .mu-card-header {
        font-size: 22pt!important!important;
      }
      .mu-list {
        .mu-item {
          font-size: 18pt!important;
        }
      }
    }
    .mu-item-title {
      font-size: 18pt!important;
    }
    .nutritionList {
      .item {
        font-size: 18pt!important;
      }
    }
    .open, .mu-appbar {
      display: none;
    }
    .page-content {
      height: 100%;
      .mu-content-block {
        padding-top: 0;
        top: 15px;
        height: 100%!important;
        width: 100%!important;
        #recipe-detail {
          display: block;
          .content {
            width: 100%!important;
            .relative {
              display: none;
            }
            .row {
              .col {
                width: 100%;
                .mu-card {
                  &:last-of-type {
                  }
                }
              }
            }
          }
          .mobileSliderPadding {
            display: none;
          }
          .insetTitleMobile {
            .row {
              .col {
                .row {
                  .col {
                    div {
                      display: none;
                    }
                    h1 {
                      font-size: 28pt!important;
                    }
                  }
                }
              }
            }
          }
          .row {
            display: block!important;
            .col {
              width: 100%!important;
              .mu-card {
                .mu-card-title {
                  font-size: 28pt!important;
                }
                .mu-card-sub-title {
                  font-size: 16pt!important;
                }
                &:last-of-type {
                  width: 100%;
                }
                .mu-list {
                  .mu-item {
                    .mu-item-content {
                      .mu-item-text {
                        span {
                          font-size: 14pt!important;
                        }
                      }
                    }
                  }
                }
              }
            }
          }

        }
      }
    }
    .sidebarOpen {
      padding-left: 0!important;
      .main-content {
        overflow: visible!important;
        position: unset;
      }
    }
    .hidePrint {
      display: none;
    }
    * { overflow: visible !important; font-size: 100%; }
    row {
      display: block!important;
    }
    .mu-list {
      position: unset!important;
    }
  }
</style>



// WEBPACK FOOTER //
// Detail.vue?04b9a59a